/* eslint-disable max-len */
import {
    fetchConfig,
    postPage,
    getInformationStatus,
    fetchFormNoticeConfig,
    getDraft,
} from '@/utils/fetch';
import {
    ROUTER_NAME_BIZ,
    ROUTER_NAME_PAGE,
    PAGE_STATUS_MAP,
    ROUTER_NAME_LANDING,
    ROUTER_NAME_CHECK,
} from '@/utils/constant';
import router from '@/router';
import { getUrlParam } from '../utils/util';
import { NOTICE_TYPE } from '@ks/mobile-general-form/src/form/const';

// 构建查询参数字符串的工具函数
function buildQueryParams(params, prefix = '&') {
    const { originBizKey, soid, source, entranceId, gameId, appId, gameVersion } = params;
    let str = `${prefix}originBizKey=${originBizKey}&soid=${soid}&source=${source}&entranceId=${entranceId}`;
    const optionalParams = [
        { key: 'gameId', value: gameId },
        { key: 'appId', value: appId },
        { key: 'gameVersion', value: gameVersion },
    ];
    optionalParams.forEach(({ key, value }) => {
        if (value) {
            str += `&${key}=${value}`;
        }
    });
    return str;
}

export default {
    async bootstrap({ commit, dispatch, state }) {
        const {
            params: {
                // 由于路由的制约，bizKey必然存在
                bizKey,
            },
            query: {
                // 业务调用可以在query的collectExtension透传JSON字符串
                collectExtension,
                from = '',
                originBizKey = '',
                soid = '',
                source = '',
                entranceId = '',
                oid = '',
                orderType = '',
                gameId = '',
                appId = '',
                gameVersion = '',
                fromCard = '',
                ...otherQuery
            },
            name,
        } = router.currentRoute;

        commit('saveOtherQuery', otherQuery);

        if (collectExtension) {
            // 如果query中有这个字段则尝试解析并存储
            try {
                commit('mutate', {
                    collectExtension: JSON.parse(collectExtension),
                });
            } catch (e) {
                // 静默失败
                // eslint-disable-next-line
                console.error(e);
            }
        }

        // 从路由 query 中读取 useTitle，如果 store 中没有就保存（只保存第一次的值）
        const { query: { useTitle: useTitleFromQuery = '' } } = router.currentRoute;
        const mutatePayload = {
            currentBizInfo: null,
            currentBizKey: bizKey,
            from,
            originBizKey,
            soid,
            source,
            entranceId,
            oid,
            orderType,
            gameId,
            appId,
            gameVersion,
            fromCard,
            viewType: Number(getUrlParam('viewType')),
        };
        // 只有在 store 中没有 useTitle 且 query 中有值时，才设置 useTitle
        if (!state.useTitle && useTitleFromQuery) {
            mutatePayload.useTitle = useTitleFromQuery;
        }

        // 更新最新的bizKey
        commit('mutate', mutatePayload);
        await dispatch('startup/reset');
        try {
            await dispatch('startup/startLoading');
            const viewType = state.viewType || Number(getUrlParam('viewType'));
            if (viewType === NOTICE_TYPE.FORM) {
                // 如果链接上有viewType参数，不请求status接口，直进form页面
                await dispatch('dealFormNotice', { name, bizKey });
                return;
            }
            const { status, bizInfo } = await dispatch('updateLandingStatus', { bizKey });
            // 当页面状态非0、5（无效、完成）时，直接跳转到landing页
            // 若为0、5状态则直接load数据，开始填写
            const notToLanding = [PAGE_STATUS_MAP.INVALID];
            // 没有from时状态为5（完成）直接load数据（原逻辑），有from则跳转到landing页
            !from && notToLanding.push(PAGE_STATUS_MAP.FINISHED);
            if (!notToLanding.includes(status)) {
                // 待处理和已驳回直接跳转到表单提交页面
                const fromPage = getUrlParam('fromPage');
                console.warn('fromPage', fromPage);
                console.warn('showNewFormInRejectStatus', bizInfo);
                if ((status === 3 && bizInfo.config.showNewFormInRejectStatus || status === 1 ) && fromPage) {
                    await dispatch('setPageInfo', { name, bizKey });
                } else {
                    const otherQueryStr = Object.keys(state.otherQuery || {}).map(k => `&${k}=${state.otherQuery[k]}`).join('');
                    const landingQueryStr = `from=${from}${buildQueryParams({ originBizKey, soid, source, entranceId, gameId, appId, gameVersion, useTitle: state.useTitle })}${otherQueryStr}`;
                    // eslint-disable-next-line max-len
                    router.replace(`/biz/${bizKey}/landing?${landingQueryStr}`);
                }
            } else {
                await dispatch('setPageInfo', { name, bizKey });
            }
            await dispatch('startup/endLoading');
        } catch (err) {
            await dispatch('startup/encounterError', err);
        }
    },
    async dealFormNotice({ dispatch }, { name, bizKey }) {
        await dispatch('setPageInfo', { name, bizKey, viewType: NOTICE_TYPE.FORM });
        await dispatch('startup/endLoading');
    },
    async updateLandingStatus({ commit, state }, { bizKey }) {
        const res = await getInformationStatus({ bizKey, ...state.otherQuery });
        const { biz = {} } = res;
        const { status, remark, data, gray = {} } = res.status;
        // status = 6;
        commit('mutate', {
            status,
            remark,
            bizInfo: biz,
            gray,
        });
        if (data && data.soid) {
            commit('saveTicket', {
                code: 1,
                soid: data.soid || '',
            });
        }
        if (data && data.myServiceBizKey) {
            commit('saveMyServiceBizKey', data.myServiceBizKey || '');
        }
        return { status, remark, bizInfo: biz };
    },
    // 处理页面当前页面数据
    // eslint-disable-next-line complexity
    async setPageInfo({ commit, dispatch, state }, { bizKey, name }) {

        bizKey = bizKey || state.currentBizKey;
        name = name || router.currentRoute.name;
        // 优先使用state中存储的viewType，如果为空则从URL获取
        const viewType = state.viewType || Number(getUrlParam('viewType'));
        const response = viewType === NOTICE_TYPE.FORM ? await fetchFormNoticeConfig({ bizKey }) : await fetchConfig({ bizKey });
        if (bizKey !== state.currentBizKey) {
            // ⚠️说明已经有另一个bootstrap，当前请求立即废弃
            return;
        }

        // 🏗 todo: 解析response合法性，ajv, 不合法直接抛出异常
        if (!response.checkPhone && (response.result !== 1 || !response.biz)) {
            throw new Error(response.error_msg || '不存在');
        }

        // 【草稿互通】在 saveInitData 之前读取服务端草稿
        // 需要短信验证（checkPhone）时跳过读取，等验证通过后页面重走初始化流程
        // 只有 INVALID(0) 状态（第一次填写、尚未提交）才读取草稿
        let serverDraft = null;
        if (!response.checkPhone && state.status === PAGE_STATUS_MAP.INVALID) {
            try {
                const draftRes = await getDraft({ bizKey });
                if (draftRes && draftRes.checkPhone) {
                    // draft/get 返回 checkPhone：草稿有数据但需要短信验真
                    // 将 checkPhone 存入 state，由 setCurrentRouter 跳转到验真页
                    commit('changeCheckPhone', draftRes.checkPhone);
                    dispatch('setCurrentRouter', { bizKey, name });
                    return;
                }
                if (draftRes && draftRes.result === 1 && draftRes.data && Object.keys(draftRes.data).length > 0) {
                    serverDraft = draftRes.data;
                }
            } catch (e) {
                // 接口失败静默降级到本地 localStorage 缓存
                // console.warn('[getDraft] 服务端草稿获取失败，降级到本地缓存', e);
            }
        }

        // ⚠️ getDraft 是异步操作，await 期间可能已切换 biz，需再次检查
        if (bizKey !== state.currentBizKey) {
            return;
        }

        if (response.checkPhone) {
            commit('changeCheckPhone', response.checkPhone);
        } else {
            commit('changeCheckPhone', '');
            // 处理数据并存储，同时传入服务端草稿
            commit('saveInitData', { response, serverDraft });
        }
        // 开始校验当前路由在当前数据的状态下是否合法
        dispatch('setCurrentRouter', { bizKey, name });
    },
    // 设置当前页面的跳转，
    setCurrentRouter({ state, getters }, { bizKey, name }) {
        console.warn('state', state, name);
        const { originBizKey, soid, source, entranceId, oid, orderType, viewType, gameId, appId, gameVersion, otherQuery } = state;
        const viewTypeStr = viewType ? `&viewType=${viewType}` : '';
        const baseParams = buildQueryParams({ originBizKey, soid, source, entranceId, gameId, appId, gameVersion });
        // 将 otherQuery（含 laneId 等透传参数）序列化追加到所有跳转 URL
        const otherQueryStr = Object.keys(otherQuery || {}).map(k => `&${k}=${otherQuery[k]}`).join('');
        const extraQueryStr = `${baseParams}&oid=${oid}&orderType=${orderType}${viewTypeStr}${otherQueryStr}`;
        const ROUTE_OPS = {
            [ROUTER_NAME_BIZ]: () => {
                if (state.checkPhone) {
                    router.replace(`/biz/${bizKey}/check?from=${state.from}${extraQueryStr}`);
                } else {
                    router.replace(`/biz/${bizKey}/page/${getters.nextPageKey || getters.headPageKey}?from=${state.from}${extraQueryStr}`);
                }
            },
            [ROUTER_NAME_LANDING]: () => {
                if (state.checkPhone) {
                    router.replace(`/biz/${bizKey}/check?from=${state.from}${extraQueryStr}`);
                } else {
                    router.replace(`/biz/${bizKey}/page/${getters.nextPageKey || getters.headPageKey}?from=${state.from}${extraQueryStr}`);
                }
            },
            [ROUTER_NAME_PAGE]: () => {
                // 检查当前page是否合法，不合法则需要跳转到合法位置
                if (-1 === getters.currentPageIndex || getters.currentPageIndex > getters.nextPageIndex) {
                    // 越位，打回第一页
                    router.replace(
                        `/biz/${bizKey}/page/${getters.nextPageKey || getters.headPageKey}?from=${state.from}${extraQueryStr}`
                    );
                } else if (state.checkPhone) {
                    router.replace(`/biz/${bizKey}/check?from=${state.from}${extraQueryStr}`);
                }
            },
            [ROUTER_NAME_CHECK]: () => {
                if (!state.checkPhone) {
                    router.replace(`/biz/${bizKey}/page/${getters.nextPageKey || getters.headPageKey}?from=${state.from}${extraQueryStr}`);
                }
            },
        };
        ROUTE_OPS[name] && ROUTE_OPS[name]();
    },
    // 同步记录路由参数
    syncRouter({ commit }, { bizKey, pageKey }) {
        commit('mutate', {
            routerBizKey: bizKey,
            routerPageKey: pageKey,
        });
    },
    // 回到的页面，开始重填
    backToPage({ state, getters }, page) {
        if (page > getters.nextPageIndex || page === getters.currentPageIndex) {
            return;
        }
        const pageKey = getters.pageNames[page];
        if (pageKey) {
            const { from, originBizKey, soid, source, entranceId } = state;
            router.push({
                params: {
                    pageKey,
                },
                query: {
                    from,
                    originBizKey,
                    soid,
                    source,
                    entranceId,
                },
            });
        }
    },
    getAllPageData({ state }) {
        // 返回合并提交接口所需要的数据结构
        return Object.entries(state.userData).map(item => ({
            pageKey: item[0],
            data: item[1],
        }));
    },
    async submit({ state, getters, dispatch, commit }, data) {
        const { extraInfo = {}, routerBizKey, routerPageKey, collectExtension, fromCard } = state;
        const { bizConfig } = getters;

        let payload;
        // 2024.04.17 目前配置后台新的信息收集配置中合并提交【mergeSubmit】默认为true。如果还有rd问你这里的逻辑，直接look这里else的逻辑截图send他。
        if (!bizConfig.mergeSubmit) {
            // 提交单页数据
            payload = {
                ...extraInfo,
                bizKey: routerBizKey,
                pageKey: routerPageKey,
                data,
            };
        } else {
            // 合并提交所有数据
            const bizData = await dispatch('getAllPageData');
            payload = {
                ...extraInfo,
                bizKey: routerBizKey,
                bizData,
            };
        }
        // 如果有业务透传字段，需要带上
        if (collectExtension !== null) {
            payload.extension = collectExtension;
        }
        // 如果打开表单时 URL 带有 fromCard=true，提交时携带该标识
        if (fromCard === 'true') {
            payload.fromCard = true;
        }
        const response = await postPage(payload);
        if (response.result !== 1) {
            throw new Error(response.error_msg || '提交失败');
        }
        commit('saveTicket', {
            code: response.code || 0,
            soid: response.data && response.data.soid || '',
        });
    },
    saveCurrentPageData({ commit }, payload) {
        commit('saveCurrentPageData', payload);
    },
    saveExtraInfo({ commit }, payload) {
        commit('saveExtraInfo', payload);
    },
    saveNextPageKey({ commit }, payload) {
        commit('saveNextPageKey', payload);
    },
};
